export default "__VITE_ASSET__C_oEUwM8__"